import getApiClient from '@/plugins/api'

export default {

    loadBoosts() {
        const self = this;
        const api = getApiClient(self.$root.$store);

        self.idTrip = this.$route.params.idTrip
        self.search = {};

        self.$store.commit('startLoading')

        self.search.page = self.page
        self.search.itemsPerPage = self.perPage
        self.search.status = '2'

        // GET
        api.get('/boosts', {
            params: self.search
        })
            .then((result) => {
                self.boosts = result.data['hydra:member'];
                self.totalPages = Math.ceil(result.data['hydra:totalItems'] / self.perPage)
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    },

    changePage: function(page) {
        this.page = page
    },

    getDescription: function(boost) {
        let description = 'Compra de impulsionamento'
        if (boost.type === 'banner') {
            description = 'Banner no site'
        }

        if (boost.type === 'featured') {
            description = 'Destaque no site'
        }

        return description
    }

}
